import React from 'react';
import { RAMGOPAL_PHOTO, SUJALA_PHOTO, DIRECTOR_PHOTO, RAJA_PHOTO, PRANAV_PHOTO, TOJO_PHOTO, SAPNA_PHOTO, WATHIQ_PHOTO, AMJAD_PHOTO, SHADI_PHOTO, SIDDHARTHA_PHOTO, NEELI_PHOTO } from '../Constants';
import "../CSS/members.css"
import "../CSS/fonts.css"
import NavBar from "../Components/NavBar"



function Members(){
    return (
        <>  
            <NavBar></NavBar>
            <h1 style = {{marginLeft : "3%",marginRight : "3%", borderBottom : "5px solid black", paddingBottom : "2%"}}  className = "roboto-condensed-700">Conference Committee</h1>
            
            <div className = "member-list">

                <div className = "position">
                    <h2 className = "roboto-condensed-700">Chief Patron</h2>
                    <div className = "members">
                        <div className="member">
                            <img src = {RAMGOPAL_PHOTO}></img>
                            <h3 className = "roboto-condensed-700">Prof. V. Ramgopal Rao</h3>
                            <h4 className = "roboto-condensed-500" >Vice Chancellor</h4>
                            <h4 className = "roboto-condensed-500" >BITS Pilani , India</h4>
                        </div>
                    </div>
                </div>
                <div className = "position">
                    <h2 className = "roboto-condensed-700">Patron</h2>
                    <div className = "members">
                        <div className="member" >
                            <img src = {DIRECTOR_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Souri Banerjee</h3>
                            <h4 className = "roboto-condensed-500">Director </h4>
                            <h4 className = "roboto-condensed-500">BITS Pilani Dubai Campus, UAE</h4>
                        </div>
                        <div className="member">
                            <img src = {SUJALA_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Sujala D Shetty</h3>
                            <h4 className = "roboto-condensed-500" >HoD of Computer Science</h4>
                            <h4 className = "roboto-condensed-500">BITS Pilani Dubai Campus, UAE</h4>
                        </div>
                    </div>
                </div>
                <div className = "position">
                    <h2 className = "roboto-condensed-700">Conference Chairs</h2>
                
                    <div className = "members">
                        <div className="member" >
                            <img src = {RAJA_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Raja Muthalagu</h3>
                            <h4 className = "roboto-condensed-500">BITS Pilani Dubai Campus, UAE</h4>
                        </div>
                        <div className="member">
                            <img src = {PRANAV_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Pranav M. Pawar</h3>
                            <h4 className = "roboto-condensed-500">BITS Pilani Dubai Campus, UAE</h4>
                        </div>
                        <div className="member">
                            <img src = {TOJO_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Tojo Mathew</h3>
                            <h4 className = "roboto-condensed-500">BITS Pilani Dubai Campus, UAE</h4>
                        </div>
                        <div className="member">
                            <img src = {SAPNA_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Sapna Sadhwani</h3>
                            <h4 className = "roboto-condensed-500">BITS Pilani Dubai Campus, UAE</h4>
                        </div>
                    </div>
                </div>
                <div className = "position">
                    <h2 className = "roboto-condensed-700">Conference Co-Chair</h2>
                    <div className = "members">
                        <div className="member">
                            <img src = {WATHIQ_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Wathiq Mansoor</h3>
                            <h4 className = "roboto-condensed-500">University of Dubai, UAE</h4>
                        </div>
                    </div>
                </div>
                <div className = "position">
                    <h2 className = "roboto-condensed-700">Technical Program Chairs</h2>
                    <div className = "members">
                        <div className="member" style = {{width : "25%"}}>
                            <img src = {AMJAD_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Amjad Gawanmeh</h3>
                            <h4 className = "roboto-condensed-500">University of Dubai, UAE</h4>
                        </div>
                        <div className="member">
                            <img src = {SHADI_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Dr. Shadi Atalla</h3>
                            <h4 className = "roboto-condensed-500">University of Dubai, UAE</h4>
                        </div>
                        <div className="member">
                            <img src = {SIDDHARTHA_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Prof. Siddhartha Bhattacharyya</h3>
                            <h4 className = "roboto-condensed-500">Florida Institute of Technology, USA</h4>
                        </div>
                        <div className="member">
                            <img src = {NEELI_PHOTO}></img>
                            <h3 className ="roboto-condensed-700">Dr. Neeli Prasad</h3>
                            <h4 className = "roboto-condensed-500">TrustedMobi</h4>
                            <h4 className = "roboto-condensed-500">VehicleAvatar Inc., USA</h4>
                        </div>
                    </div>
                </div>
                <div className = "position-sub">
                    <h2 className = "roboto-condensed-700">International Advisory Committee</h2>
                    <div className="main-member-list">
                        <div className = "member-list-leaflet">
                            <li className = "roboto-condensed-300"><p>Prof. Siddhartha Bhattacharyya, Florida Institute of Technology, USA</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Neeli Prasad, TrustedMobi “VehicleAvatar Inc.”, USA</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Antonis Michalis, Tampere University, Finland</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Amir Leshem, Bar Ilan Univesity, Israel</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Ramjee Prasad, Professor, President, CGC Denmark</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Albena Mihovska, TrustedMobi “VehicleAvatar Inc.”, USA</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Balasubramanian R, IIT-Roorkee, India</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Balaji Srinivasan, IIT-Madras, India</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Rahul CS, IIT, Goa, India</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Surendiran B, NIT Trichy, India</p></li>
                            <li className = "roboto-condensed-300"><p>Mr. Murali Sundaram, Gen AI Consultant, IIT-Madras, India</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. R. Rama, IIT-Madras, India</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Antonis Michalis, Tampere University, Finland</p></li>
                        </div>
                        <div className = "member-list-leaflet">
                            <li className = "roboto-condensed-300"><p>Prof. P. Muthuchidambaranathan, NITT, India</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Nick Pears, Department of Computer Science, University of York, UK</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Sohini Roychowdhury, Global Head of AI, Accenture, San Francisco, USA</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Bakaev Maxim Alexandrovich, Novosibirsk State Technical University, Russia Prof. Roberto       Pereira, Federal University of Paraná (UFPR), Curitiba, Brazil.</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. N. Ramasubramanian, NIT-Trichy, India</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Dnyaeshwar Mantri, University of Pune, India</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Prabhat Kumar Upadhyay, IIT-Indore, India</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Rasmus H Nielsen, Movimento, USAProf. Siddhartha Bhattacharyya, Florida Institute of       Technology, USA</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Praveen Kumar Yadav, Research and Development Panasonic, Singapore</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Jeny Rajan, NITK, Surathkal, India</p></li>
                            <li className = "roboto-condensed-300"><p>Ms. Aayushi Jangid, Boston Consulting Group, San Franscisco, USA</p></li>
                        </div>
                    </div>
                </div>
                <div className = "position-sub">
                    <h2 className = "roboto-condensed-700">Technical Program Committee</h2>
                    <div className="main-member-list">
                        <div className = "member-list-leaflet">
                            
                            <li className = "roboto-condensed-300"><p>Prof. Monther Aldwairi, Zayed University, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Snehanshu Saha, BITS Pilani, Goa Campus, India</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Balasubramanian Raman, IIT Roorkee, India</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Chitaranjan Hota, BITS Pilani, Hyderabad Campus, India</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Pradeep Kumar Arya, Bennett university, India</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Imran A. Zualkernan, American University of Sharjah, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Saad Harous, University of Sharjah, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Siddhaling Urolagin, Middlesex University, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Mohd Nazir, Zayed University, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Rahul Mishra, IIT Patna, India</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Anshul Sharma, NIT Patna, India</p></li>
                            <li className = "roboto-condensed-300"><p>⁠Dr. Federico Coro, University of Padua, Italy</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Alavi Kunhu, University of Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Vijaykumar B, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Sujala D Shetty, BITS Pilani, Dubai Campus, UAE</p></li>                                 
                        </div>
                        <div className = "member-list-leaflet">
                            <li className = "roboto-condensed-300"><p>Dr. Angel A Jothi, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Tamizharasan Periyasamy, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Elakkiya R, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Ashish Gupta, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Mithun Mukhrjee, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Kajan Kansal, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Hussain Ahmed Chowdhury, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Suyash Shukla, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Alberto Marchisio, NYU Abu Dhabi, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Subramaniyaswamy, India</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. R K Mishra, De Montfort University, Kazakhstan</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Roberto Pereira, Federal University of Paraná, Curitiba, Brazil.</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Jyotika Singh, Principal Applied Scientist, Oracle, USA</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Bakaev Maxim Alexandrovich, NSTU, Russia</p></li>
                            <li className = "roboto-condensed-300"><p>Prof. Michele Fiorentino, Politecnico Di Bari, Bari, Italy</p></li>
                        </div>
                    </div>
                </div>
                <div className = "position-sub">
                    <h2 className = "roboto-condensed-700">Local Organizing Committee</h2>
                    <div className="main-member-list">
                        <div className = "member-list-leaflet">
                            <li className = "roboto-condensed-300"><p>Dr. B. Vijayakumar, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Sujala D Shetty, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Angel A Jothi, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Tamizharasan Periyasamy, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Elakkiya R, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Ashish Gupta, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Mithun Mukhrjee, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Kajan Kansal, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Hussain Ahmed Chowdhury, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Suyash Shukla, BITS Pilani, Dubai, UAE</p></li>             
                        </div>
                        <div className = "member-list-leaflet">
                            <li className = "roboto-condensed-300"><p>Dr. Shivang Agrawal, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Keshav Kaushik, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Dr. Amanjot Kaur, BITS Pilani, Dubai, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Mr. Kashyap Shah, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Ms. Sheeba Uruj, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Ms. Umarani S, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Ms. Veena Srinivas, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Ms. Blessy Chacko, BITS Pilani, Dubai Campus, UAE</p></li>
                            <li className = "roboto-condensed-300"><p>Mr. Subhasis Patra, BITS Pilani, Dubai Campus, UAE</p></li>
                        </div>
                    </div>
                </div>

            </div>
        </>


    )
}

export default Members